import React from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/bff/client';
import { MobileMenu } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/MobileMenu.css';

import LanguageSwitcherContainer from './LanguageSwitcher';
import LogoLink from './LogoLink';
import LoginButton from './login/LoginButton';

const MobileNav = ({ onClose }) => (
  <MobileMenu
    logo={
      <LogoLink
        link={getPagePath('externals.landing-pages.home')}
        color="green"
      />
    }
    className="homeMobileMenu"
    onClose={onClose}
  >
    <MobileMenu.List>
      <MobileMenu.Item>
        <MobileMenu.Link
          className="ga-home"
          href={getPagePath('externals.landing-pages.home')}
        >
          {trans('landing-pages.home')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Item>
        <MobileMenu.Link
          href={getPagePath('externals.landing-pages.list-your-property')}
        >
          {trans('landingpage.button.landlord')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Item>
        <MobileMenu.Link
          href={getPagePath('externals.landing-pages.how-it-works')}
          target="_blank"
        >
          {trans('how_it_works.title')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Item>
        <MobileMenu.Link
          href={getPagePath('externals.marketplace.favorites')}
          target="_blank"
        >
          {trans('favorites.title.favorites')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Separator />

      <LoginButton isMobile />

      <MobileMenu.Separator />

      <MobileMenu.Item>
        <MobileMenu.Link
          href={getPagePath('externals.landing-pages.help-center')}
        >
          {trans('help.title')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Item>
        <MobileMenu.Link>
          <LanguageSwitcherContainer />
        </MobileMenu.Link>
      </MobileMenu.Item>
    </MobileMenu.List>
  </MobileMenu>
);

MobileNav.defaultProps = {
  onClose: () => {}
};

MobileNav.propTypes = {
  onClose: PropTypes.func
};

export default MobileNav;
